import { postRequest } from '.';
import { ReceiptData } from '/types/index';

export const startReceipt = async (trackingId: string, userId: string, stationId: string) =>
  postRequest('receipt-arrived', {
    // TODO: rpaas-receipt-arrived-ui rpaas-receipt-arrived-adidas rpaas-receipt-arrived-message-adidas

    tracking_id: trackingId,
    user_id: userId,
    station_id: stationId,
    receipt_start_timestamp: new Date().toISOString(),
  });

export const closeReceipt = async (receiptData: ReceiptData) =>
  postRequest('close-receipt', receiptData);

export const finishReceipt = async (
  transactionId: string | number,
  userId: string,
  stationId: string
) =>
  postRequest('receipt-graded-finish', {
    // TODO: it should be rpaas-receipt-graded-finish-ui

    transaction_id: transactionId,
    user_id: userId,
    station_id: stationId,
    override_ind: 'y',
  });
